/* Lightweight logger — stays silent in production builds. */
const isDev = process.env.NODE_ENV !== 'production';

export const logError = (...args) => {
  // eslint-disable-next-line no-console
  if (isDev) console.error(...args);
};

export const logDebug = (...args) => {
  // eslint-disable-next-line no-console
  if (isDev) console.debug(...args);
};
